"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserVipInfo = getUserVipInfo;
exports.getVipInfo = getVipInfo;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _helper = require("./helper");
var _ajax = require("./ajax");
// eslint-disable-next-line @tencent/tdoc-standalone/no-use-location-host
var url = "//".concat(location.hostname, "/cgi-bin/online_docs/user_info");
var userInfo = false;

// 只取一次.
function getUserVipInfo(callBack) {
  if (userInfo) {
    callBack(userInfo);
    return;
  }
  var param = "get_vip_info=1&xsrf=".concat((0, _helper.getXsrf)(), "&_s=sc");
  (0, _ajax.ajaxGet)(url, param).then(function (data) {
    if (callBack && typeof callBack === 'function') {
      userInfo = data;
      callBack(data);
    }
  }).catch(function (data) {
    callBack(data);
  });
}
;
function getVipInfo() {
  return _getVipInfo.apply(this, arguments);
}
function _getVipInfo() {
  _getVipInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            try {
              getUserVipInfo(function (data) {
                if (data && data.retcode === 0) {
                  resolve(data);
                } else {
                  resolve({
                    retcode: -1
                  });
                }
              });
            } catch (error) {
              console.error(error);
              resolve({
                retcode: -1
              });
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getVipInfo.apply(this, arguments);
}